export default __webpack_public_path__ + "static/media/video-no.cfbbf614.svg";